import { createAppAsyncThunk } from '@/redux/create-app-thunk';

export const validateDiscountCode = createAppAsyncThunk(
  'validateDiscountCode',
  async (payload: {discountCode: string}, { rejectWithValue, getState, extra: { checkoutService } }) => {
    const storeId = getState().root.storeConf.storeId;
    try {
      return await checkoutService.updateDiscountCode(storeId, payload.discountCode);
    } catch (error) {
      return rejectWithValue({ error: error.error });
    }
  }
);
